import {
  ThemeUICSSObject,
  focusOutline,
  responsive,
  spacing,
} from '@apia/theme';
/* IMPORT HERE */

const filteredMenu: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(5),
  minWidth: responsive({ 0: '100%', 3: '400px' }),
  padding: '3px',
  width: '100%',

  '.filteredMenu__item:focus': focusOutline,

  '.filteredMenu__item': {
    p: spacing(3),

    img: {
      borderRadius: '9999px',
    },

    '.button__content': {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(3),
      justifyContent: 'start',
      padding: '3px',
      width: '100%',
    },
  },

  '.tree': {
    height: '208px',
    overflow: 'auto',
  },

  '.tree__searchLabelBox': {
    top: 0,
  },

  '.tree__nodeItemLabelRenderer': {},

  '.tree__nodeItemLabelRenderer, .filteredMenu__item': (theme) => ({
    ...theme.palette.getStatesFromDefinition({
      backgroundColor: 'rgb(232 241 249 / 30%)',
    }),
    justifyContent: 'start',
    width: '100%',
  }),

  'ul[role="tree"]': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
    justifyContent: 'stretch',
  },
};

export default filteredMenu;
